import { useQuery } from '@tanstack/react-query';
import getBrandListRequest from './model/request/getBrandListRequest';
import getBrandList from 'Api/target/getBrandList';
import getBrandListResponse from './model/response/getBrandListResponse';

const useGetBrandList = (yearMonth) => {
  return useQuery({
    queryKey: ['target-brand-list', yearMonth],
    queryFn: async () => {
      const queries = getBrandListRequest(yearMonth);

      const response = await getBrandList(queries);

      const result = getBrandListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: yearMonth !== null,
  });
};

export default useGetBrandList;
